import React from "react";
import { getReactCMSComponent } from "./getReactCMSComponent";
import { IterableModule } from "./types/modules/util/module";
import { LayoutContainer } from "@shared-components/LayoutContainer/LayoutContainer";
import { generateCbKey } from "../shared/utils/generate-cbKey";

export interface ModulesRendererProps {
  modules: IterableModule[];
  disableLayoutRendering?: boolean;
}

const ModulesRenderer: React.FC<ModulesRendererProps> = ({
  modules,
  disableLayoutRendering,
}) => {
  if (!modules) {
    return null;
  }

  if (disableLayoutRendering)
    return (
      <>
        {modules.map(({ alias, ...props }) =>
          getReactCMSComponent({
            alias,
            props,
          })
        )}
      </>
    );

  return (
    <>
      {modules.map(({ alias, ...props }, index) => (
        <LayoutContainer
          key={generateCbKey()}
          id={props?.key as string}
          taxonomies={props?.taxonomies}
          themes={props?.themes}
          disableAnimate={index === 0}
        >
          {getReactCMSComponent({
            alias,
            props,
          })}
        </LayoutContainer>
      ))}
    </>
  );
};

export { ModulesRenderer };
